import React from 'react'
import styles from './context-menu.styles'
import injectSheet from 'react-jss'
import MoreButton from 'pobble-components/dist/more-button'
import DropMenu from 'pobble-components/dist/drop-menu'
import TrashIcon from 'react-icons/lib/fa/trash-o'
import CheckIcon from 'react-icons/lib/fa/check-circle-o'
import CircleIcon from 'react-icons/lib/fa/circle-o'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import CopyIcon from 'react-icons/lib/fa/copy'

const ContextMenu = ({
  classes,
  onRemove,
  onCopy,
  onMarkAsSeen,
  onMarkAsUnseen,
  seen,
  canMarkAsBenchmark
}) => (
  <DropMenu
    button={({ ref, togglePopover }) => (
      <MoreButton forwardedRef={ref} onClick={togglePopover} />
    )}>
    {({ Menu, MenuItem, IconHolder, Separator, closePopover }) => (
      <Menu>
        {canMarkAsBenchmark && (
          <MenuItem
            onClick={() => {
              closePopover()
              onCopy()
            }}>
            <IconHolder>
              <CopyIcon />
            </IconHolder>
            Copy file
          </MenuItem>
        )}
        {!seen && (
          <MenuItem
            onClick={() => {
              closePopover()
              onMarkAsSeen()
            }}>
            <IconHolder>
              <CheckIcon />
            </IconHolder>
            Mark as seen
          </MenuItem>
        )}
        {seen && (
          <MenuItem
            onClick={() => {
              closePopover()
              onMarkAsUnseen()
            }}>
            <IconHolder>
              <CircleIcon />
            </IconHolder>
            Mark as unseen
          </MenuItem>
        )}
        <MenuItem
          className={classes.remove}
          onClick={() => {
            openConfirmationDialog({
              bodyText: 'Are you sure you want to archive this invitation?',
              action: onRemove,
              confirmText: 'Archive',
              cancelText: 'Cancel'
            })
            closePopover()
          }}>
          <IconHolder>
            <TrashIcon />
          </IconHolder>
          Archive
        </MenuItem>
      </Menu>
    )}
  </DropMenu>
)

export default injectSheet(styles)(ContextMenu)
